<template>
    <v-dialog v-model="dialog" width="500">
        <template v-slot:activator="{ on: dialog }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn icon
                           color="primary"
                           v-on="{ ...dialog, ...tooltip }"
                    >
                        <v-icon>mdi-plus-box</v-icon>
                    </v-btn>
                </template>
                <span>Create Item</span>
            </v-tooltip>
        </template>

        <v-card>
            <v-card-title>
                Create Item
            </v-card-title>

            <v-card-text>
                <v-text-field v-model="form.number"
                              type="number"
                              @keydown.enter="storeItem"
                              label="Number"/>
                <v-text-field v-model="form.title"
                              @keydown.enter="storeItem"
                              label="Name"/>
                <v-textarea v-model="form.description"
                            label="Description"/>
                <v-text-field v-model="form.amount"
                              type="number"
                              @keydown.enter="storeItem"
                              label="Number of Items"/>
                <v-text-field v-model="form.cost"
                              type="number"
                              @keydown.enter="storeItem"
                              label="Cost"/>
                <v-select v-model="form.slot"
                          :items="slots"
                          item-text="title"
                          item-value="id"
                          label="Slot"/>
                <v-select v-model="form.discard_effect"
                          :items="discardEffects"
                          item-text="title"
                          item-value="id"
                          label="Discard Effect"/>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="secondary" text @click="dialog = false">
                    Cancel
                </v-btn>
                <v-btn color="primary" text @click="storeItem">
                    Submit
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import ItemService from "../services/ItemService";

  export default {
    props: ['campaign'],

    data: () => ({
      loading: false,
      dialog: false,
      form: {
        number: null,
        title: null,
        description: null,
        amount: null,
        cost: null,
        slot: null,
        discard_effect: null
      },
      slots: [],
      discardEffects: []
    }),

    created() {
      this.getSlots();
      this.getDiscardEffects();
    },

    methods: {
      storeItem() {
        this.loading = true;
        this.form.campaign_id = this.campaign.id;

        ItemService.store(this.form)
          .then(response => {
            this.$emit('itemStored', response.data.data);
            this.loading = false;
            this.dialog = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      },

      getSlots() {
        ItemService.slots()
          .then(response => {
            this.slots = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      getDiscardEffects() {
        ItemService.discardEffects()
          .then(response => {
            this.discardEffects = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
</script>
